/**
 * notificationMeta.js — Logique partagée des notifications (§9 DRY).
 * Source unique : catégorie dérivée du texte + visuel (icône/gradient) + temps relatif.
 * Utilisé par la PAGE Notifications ET le WIDGET cloche du header (cohérence garantie).
 */
import { COLORS } from '../../components/ui/theme';
import { formatDate } from '../format';

/** Déduit la catégorie d'une notification depuis son texte `desc`. */
export function categoryOf(desc = '') {
  const d = (desc || '').toLowerCase();
  if (d.includes('earned a royalty') || d.includes('earned a commission')) return 'royalties';
  if (d.includes('has been sold')) return 'sales';
  if (d.startsWith('you purchased')) return 'purchases';
  if (d.includes('transferred to') || d.startsWith('you received')) return 'transfers';
  if (d.includes('listed for sale') || d.includes('no longer listed')) return 'listings';
  if (d.includes('wishlist')) return 'wishlist';
  if (d.includes('liked')) return 'likes';
  return 'other';
}

/** Visuel (icône emoji + gradient de fond) par catégorie. */
export function categoryVisual(cat) {
  switch (cat) {
    case 'royalties': return { icon: '💰', bg: 'linear-gradient(135deg,#F4B740,#c98a00)' };
    case 'sales': return { icon: '🏷️', bg: `linear-gradient(135deg,${COLORS.accent},${COLORS.accent2})` };
    case 'purchases': return { icon: '🛒', bg: 'linear-gradient(135deg,#1FCB5C,#0a8f3c)' };
    case 'transfers': return { icon: '📤', bg: 'linear-gradient(135deg,#3b5bdb,#1e2d7a)' };
    case 'listings': return { icon: '📣', bg: `linear-gradient(135deg,${COLORS.accent},#5b1e8a)` };
    case 'likes': return { icon: '❤️', bg: 'linear-gradient(135deg,#e6396b,#a01545)' };
    case 'wishlist': return { icon: '⭐', bg: 'linear-gradient(135deg,#F4B740,#c98a00)' };
    default: return { icon: '🔔', bg: `linear-gradient(135deg,${COLORS.accent},#5b1e8a)` };
  }
}

/** Temps relatif lisible (ex. "10 minutes ago", "Yesterday"). */
export function relativeTime(iso) {
  if (!iso) return '';
  const then = new Date(String(iso).replace(' ', 'T'));
  const diff = Math.floor((Date.now() - then.getTime()) / 1000);
  if (isNaN(diff)) return '';
  if (diff < 60) return 'Just now';
  if (diff < 3600) { const m = Math.floor(diff / 60); return `${m} minute${m > 1 ? 's' : ''} ago`; }
  if (diff < 86400) { const h = Math.floor(diff / 3600); return `${h} hour${h > 1 ? 's' : ''} ago`; }
  if (diff < 172800) return 'Yesterday';
  const dd = Math.floor(diff / 86400);
  if (dd < 7) return `${dd} days ago`;
  return formatDate(then);
}

/** Âge en jours (filtres de date). */
export function ageDays(iso) {
  const then = new Date(String(iso).replace(' ', 'T'));
  return (Date.now() - then.getTime()) / 86400000;
}
